import store from "../../store";
import { DATAS } from "@/datas";
import API_ENTRIES from "@/datas/authservice/entries.js";
import API_SHOPLUSE_ENTRIES from "@/datas/authservice/shoplus-entries.js";

/**
 * /router/index.js
 * store 정보 세팅
 */
export default class SetStoreInfo {
  /**
   *
   * @param {*} router
   * @param {*} type
   */
  constructor(router, path) {
    this.router = router;
    this.appCode = DATAS.ASA_APP_CODE;

    this.setStoreCommon();
    switch (path) {
      case "shoplus_service":
      case "shoplus_authservice":
        store.commit("SET_MALL_TYPE", "shoplus");
        this.setStoreShoplus();
        break;
      default:
        this.setStoreCafe24();
        break;
    }
  }

  /**
   * 공통 설정
   */
  setStoreCommon() {
    if (!store.state.appCode) {
      store.commit("SET_APP_CODE", this.appCode);
    }
  }

  /**
   * CAFE24 store 설정
   */
  setStoreCafe24() {
    if (!store.state.entries || !Array.isArray(store.state.entries)) {
      store.commit("SET_ENTRIES", API_ENTRIES);
    }

    this.router.beforeEach(async (to, from, next) => {
      try {
        if (!store.state.mallId) {
          let mall_id = to.query.mall_id;
          if (mall_id && Array.isArray(mall_id)) {
            mall_id = mall_id[0];
          }
          if (!mall_id) {
            mall_id = to.params.mall_id;
          }
          if (!mall_id) {
            throw new Error("requireAuth");
          }
          store.commit("SET_MALL_ID", mall_id);
        }

        if (!store.state.accessToken) {
          let access_token = to.query.access_token;
          if (!access_token) {
            access_token = localStorage.getItem(
              `${store.state.mallId}_accessToken`
            );
            if (!access_token) {
              throw new Error("requireAuth");
            }
          }
          await store.dispatch("SET_ACCESS_TOKEN", {
            access_token: access_token,
          });
        }

        if (store.state.mode === null) {
          await store.dispatch("SET_CERT_PRODUCTS_VERSION");
        }
        if (!store.state.mode) {
          throw new Error("requirePayment");
        }

        if (
          to.matched.some(
            (route) =>
              route.meta.requireModes === undefined ||
              (Array.isArray(route.meta.requireModes) &&
                route.meta.requireModes.includes(store.state.mode))
          )
        ) {
          next();
        } else {
          // 무한호출됨..
          // throw new Error("requirePayment");
        }
      } catch (error) {
        switch (error.message) {
          case "requireAuth":
            window.location.href = `https://${store.state.mallId}.cafe24.com/disp/admin/shop1/myapps/list`;
            break;
          case "requirePayment":
            next({ path: `/authservice/${store.state.mallId}/payment` });
            break;
          default:
            next();
            break;
        }
      }
    });
  }
  /**
   * Shoplus store 설정
   */
  setStoreShoplus() {
    if (!store.state.entries || !Array.isArray(store.state.entries)) {
      store.commit("SET_ENTRIES", API_SHOPLUSE_ENTRIES);
    }

    this.router.beforeEach(async (to, from, next) => {
      try {
        //partner User Id
        let partnerId = sessionStorage.shoplusAuthServiceId;
        //access-token
        let accessToken = sessionStorage.shoplusAuthServiceAccessToken;
        //refresh-token
        let refreshToken = localStorage.shoplusAuthServiceRefreshToken;

        if (partnerId) {
          store.commit("SET_MALL_ID", partnerId);
        }

        if (accessToken) {
          await store.dispatch("SET_SHOPLUS_ACCESS_TOKEN", accessToken);
        }

        if (refreshToken) {
          await store.dispatch("SET_SHOPLUS_REFRESH_TOKEN", refreshToken);
        }
        next();
      } catch (e) {
        switch (e.message) {
          case "requireAuth":
            store.state.mallId = null;
            window.location.href = "/shoplus_service";
            break;
          default:
            next();
            break;
        }
      }
      next();
    });
  }
}
